import { Group, Text } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import React from 'react'
import { useDropzone } from 'react-dropzone'

const styles = {
  dropzone: {
    width: '40%',
    height: 90,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5,
    padding: '0 20px',
    margin: '20px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },

  dropzoneError: {
    order: 100,
    fontSize: 12,
    lineHeight: '12px',
    color: 'rgb(244, 67, 54)',
    width: '100%',
  },
}
export const renderDropzoneField = (data: any) => {
  const {
    input,
    meta: { dirty, error },
  } = data
  const convertTypePreview = (files: File[]) =>
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      }),
    )
  const onDrop = (acceptedFiles: File[]) =>
    input.onDrop(convertTypePreview(acceptedFiles))
  const onDropAccepted = (files: File[]) =>
    input.onChange(convertTypePreview(files))

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onDropAccepted,
  })

  return (
    <div>
      <div {...getRootProps()} style={styles.dropzone}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p> ファイルをこちらにドロップするとアップロードされます。</p>
        ) : (
          <p>
            ファイルをドロップするかクリックしてファイルを選択するとアップロードされます。
          </p>
        )}
      </div>
      {dirty && error && <span style={styles.dropzoneError}>{error}</span>}
    </div>
  )
}

export const MyDropzone = ({ onDrop }: { onDrop: (files: File[]) => void }) => {
  return (
    <Dropzone onDrop={onDrop} p={30} mih={120} w="60%" style={{ justifySelf: 'center' }}>
      <Group justify="center" style={{ pointerEvents: 'none' }}>
        <Dropzone.Idle>
          <Text ta="center">
            ファイルをドロップするかクリックしてファイルを選択するとアップロードされます。複数選択も可能です。
          </Text>
        </Dropzone.Idle>
        <Dropzone.Accept>
          <Text ta="center">
            ファイルをこちらにドロップするとアップロードされます。複数選択も可能です。
          </Text>
        </Dropzone.Accept>
      </Group>
    </Dropzone>
  )
}
